import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/landing/main/cover.webp'


const _hoisted_1 = { class: "relative" }
const _hoisted_2 = { class: "mx-auto max-w-7xl" }
const _hoisted_3 = { class: "relative z-10 pt-14 lg:w-full lg:max-w-2xl" }
const _hoisted_4 = { class: "relative px-8 sm:px-none py-16 sm:py-32 lg:pr-0" }
const _hoisted_5 = { class: "mx-auto max-w-2xl lg:mx-0 lg:max-w-xl" }
const _hoisted_6 = { class: "hidden sm:mb-10 sm:flex" }
const _hoisted_7 = { class: "mt-10 flex items-center gap-x-6" }

import { useI18n } from 'vue-i18n';
import UiTag from '@/components/ui/UiTag.vue';
import UiTitle from '@/components/ui/UiTitle.vue';
import UiParagraph from '@/components/ui/UiParagraph.vue';
import UiButton from '@/components/ui/UiButton.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'MainSection',
  setup(__props) {

const { t } = useI18n();

// Methods
const openForm = () => {
  window.open(t('pages.home.mainSection.form-url'), '_blank');
};

const navigateTo = (id: string) => {
  const element = document.getElementById(id);
  element?.scrollIntoView({ behavior: 'smooth' });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[3] || (_cache[3] = _createElementVNode("svg", {
          class: "absolute inset-y-0 right-8 hidden h-full w-80 translate-x-1/2 transform fill-gray-100 dark:fill-gray-900 lg:block",
          viewBox: "0 0 100 100",
          preserveAspectRatio: "none",
          "aria-hidden": "true"
        }, [
          _createElementVNode("polygon", { points: "0,0 90,0 50,100 0,100" })
        ], -1)),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createVNode(UiTag, {
                href: "#",
                "link-text": _unref(t)('pages.home.mainSection.about-anchor')
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('pages.home.mainSection.tag')), 1)
                ]),
                _: 1
              }, 8, ["link-text"])
            ]),
            _createVNode(UiTitle, {
              size: "7xl",
              align: "left",
              color: "gray"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('pages.home.mainSection.title')), 1)
              ]),
              _: 1
            }),
            _createVNode(UiParagraph, {
              size: "xl",
              align: "left",
              color: "gray",
              class: "mt-8"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('pages.home.mainSection.description')), 1)
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_7, [
              _createVNode(UiButton, {
                variant: "primary",
                size: "md",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (openForm()))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('pages.home.mainSection.button')), 1)
                ]),
                _: 1
              }),
              _createVNode(UiButton, {
                variant: "ghost",
                size: "md",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (navigateTo('how-it-works')))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('pages.home.mainSection.learn-button')) + " ", 1),
                  _cache[2] || (_cache[2] = _createElementVNode("span", {
                    "aria-hidden": "true",
                    class: "ml-2"
                  }, "→", -1))
                ]),
                _: 1,
                __: [2]
              })
            ])
          ])
        ])
      ])
    ]),
    _cache[4] || (_cache[4] = _createElementVNode("div", { class: "lg:absolute lg:inset-y-0 lg:right-0 lg:w-1/2" }, [
      _createElementVNode("img", {
        class: "aspect-3/2 object-cover lg:aspect-auto lg:size-full",
        src: _imports_0,
        alt: ""
      })
    ], -1))
  ]))
}
}

})